import { render } from "./ProfileProjects.vue?vue&type=template&id=73b090df"
import script from "./ProfileProjects.vue?vue&type=script&lang=js"
export * from "./ProfileProjects.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Desktop/projNii/ERP/rada-erp-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__